import OnScreen from 'onscreen';

export default {
  init() {

    function video_active() {
      $('.about_us__header__video__inner').addClass('about_us__header__video__inner--active');
    }

    const os = new OnScreen();
    // JavaScript to be fired on the home page, after the init JS
    os.on('enter', '.js-lines', (element) => {
      if (element.classList.contains('js-lines-init') && ($.screenwidth() >= 990)) {
        element.classList.remove('js-lines-init');
        element.className += ' js-lines-active';
      }
    });
    os.on('leave', '.js-lines', (element) => {
      if (element.classList.contains('js-lines-active') && ($.screenwidth() >= 990)) {
        element.classList.remove('js-lines-active');
        element.className += ' js-lines-init';
      }
    });
    os.on('enter', '.add_fadeInUp ', (element) => {
      if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
        element.classList.remove('add_fadeInUp');
        element.className += ' fadeInUp  show';
      }
    });

    os.on('enter', '.add_fadeInDown ', (element) => {
      if (element.classList.contains('add_fadeInDown') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
        element.classList.remove('add_fadeInDown');
        element.className += ' fadeInDown  show';
      }
    });
    os.on('enter', '.home__work ', () => {
      Array.prototype.forEach.call(document.getElementsByClassName('home__dots'), function (element) {
        if (!element.classList.contains('home__dots--active')) {
          element.className += ' home__dots--active';
        }
      });
    });

    // Prasárna na to nekoukat
    $('#about_us__header__video__inner__iframe').load(function () {
      $(this).contents().on('mousedown, mouseup, click', function () {
        video_active();
      });
    });


    $('#about_us__header__video__inner__iframe').contents().find('a:first').on('click', function () {
      video_active();
    });



    if ($(window).width() < 990) {

      $('#team__inner').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '50px',
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js